import { Platform } from 'react-native';

/**
 * Layout constants local to the marketing landing page (route: /landing).
 *
 * The landing is a wide, centred marketing surface (max 1440px, generous
 * gutters) and deliberately does NOT reuse the app-wide `layout` tokens
 * from `src/styles/layout.ts` — those drive the dense in-app shell
 * (maxWidth: '100%', paddingH: 12) and would make the landing look
 * cramped / edge-to-edge.
 */
export const landingLayout = {
  maxWidth: 1440,
  paddingH: Platform.OS === 'web' ? 80 : 24,
} as const;
